<template>
  <div class="layout--main" :class="[navbarClass, footerClass, {'app-page': isAppPage}]">
    <vx-sidebar
      :sidebarItems="sidebarItems"
      title="Vuesax"
      parent=".layout--main"
    />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

      <div class="content-wrapper">
        <the-navbar
          @click:button="changeSideBarItems"
          :navbarColor="navbarColor"
          :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]"
        />

        <div class="router-view">
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
            <transition :name="routerTransition">
              <div
                class="router-header flex flex-wrap items-center mb-6"
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
              >
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                />

                <!-- DROPDOWN -->
                <vs-dropdown class="ml-auto md:block hidden cursor-pointer" vs-trigger-click>
                  <vs-button radius icon="icon-settings" icon-pack="feather"></vs-button>

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div @click="$router.push('/pages/profile')" class="flex items-center">
                        <feather-icon
                          icon="UserIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Perfil</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </transition>
            <div class="content-area__content">
              <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import BackToTop from "vue-backtotop"

import themeConfig from "@/../themeConfig.js"
import TheNavbar from "@/components/TheNavbar.vue"
import TheFooter from "@/components/TheFooter.vue"
import sidebarListItems from '@/constants/SidebarItems'
import VxSidebar from "@/layouts/components/vx-sidebar/VxSidebar.vue"
import sidebarItemsClinic from "@/layouts/components/vx-sidebar/sidebarItemsClinic.js"
import sidebarItemsDoctor from "@/layouts/components/vx-sidebar/sidebarItemsDoctor.js"
import sidebarItemsConsultant from "@/layouts/components/vx-sidebar/sidebarItemsConsultant.js"
import sidebarItemsFinancial from "@/layouts/components/vx-sidebar/sidebarItemsFinancial.js"
import sidebarItemsCommercial from "@/layouts/components/vx-sidebar/sidebarItemsCommercial.js"
import sidebarItemsHelpDesk from "@/layouts/components/vx-sidebar/sidebarItemsHelpDesk.js"
import sidebarItemsTechnology from "@/layouts/components/vx-sidebar/sidebarItemsTechnology.js"
import sidebarItemsIndicators from "@/layouts/components/vx-sidebar/sidebarItemsIndicators.js"

export default {
  name: "MainLayout",

  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    BackToTop
  },
  data() {
    return {
      sidebarType: "",
      navbarType: themeConfig.navbarType || "floating",
      navbarColor: themeConfig.navbarColor || "#fff",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour
    };
  },
  computed: {
    isAppPage() {
      return this.$route.path.includes("/apps/")
    },
    isThemeDark() {
      return this.$store.state.theme == "dark"
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") {
        return "content-area-default"
      } else if (this.sidebarWidth == "reduced") {
        return "content-area-reduced"
      } else if (this.sidebarWidth) {
        return "content-area-full"
      }
    },
    navbarClass() {
      return `navbar-${this.navbarType}`
    },
    footerClass() {
      return `footer-${this.footerType}`
    },
    sidebarItems() {
      if (this.sidebarType === "clinic") {
        return this.sidebarItemsClinic
      }
      if (this.sidebarType === "doctor") {
        return this.sidebarItemsDoctor
      }
      if (this.sidebarType === "consultant") {
        return this.sidebarItemsConsultant
      }
      if (this.sidebarType === "financial") {
        return this.sidebarItemsFinancial
      }
      if (this.sidebarType === "commercial") {
        return this.sidebarItemsCommercial
      }
      if (this.sidebarType === "technology") {
        return this.sidebarItemsHelpDesk
      }
      if (this.sidebarType === "helpdesk") {
        return this.sidebarItemsTechnology
      }
      if (this.sidebarType === "indicators") {
        return this.sidebarItemsIndicators
      }
      return []
    }
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
      this.sidebarRoutes();
    },
    isThemeDark(val) {
      this.updateNavbarColor(this.navbarColor == "#fff" && val ? "#10163A" : "#fff")
    }
  },
  setup() {
    return {
      sidebarListItems,
      sidebarItemsClinic,
      sidebarItemsDoctor,
      sidebarItemsConsultant,
      sidebarItemsFinancial,
      sidebarItemsCommercial,
      sidebarItemsHelpDesk,
      sidebarItemsTechnology,
      sidebarItemsIndicators,
    }
  },
  created() {
    this.setSidebarWidth();
    window.addEventListener("routes-sidebar", this.sidebarRoutes());
    this.sidebarRoutes();

    if (this.navbarColor == "#fff" && this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
  },
  destroyed() {
    window.removeEventListener("routes-sidebar", this.sidebarRoutes());
    this.sidebarRoutes();
  },
  methods: {
    sidebarRoutes() {
      if (this.sidebarListItems.clinic.includes(this.$store.state.hashPath)) {
        this.changeSideBarItems("clinic")
      }
      
      if (this.sidebarListItems.doctor.includes(this.$store.state.hashPath)) {
        this.changeSideBarItems("doctor")
      }
      
      if (this.sidebarListItems.consultant.includes(this.$store.state.hashPath)) {
        this.changeSideBarItems("consultant")
      }
      
      if (this.sidebarListItems.financial.includes(this.$store.state.hashPath)) {
        this.changeSideBarItems("financial")
      }
      
      if (this.sidebarListItems.commercial.includes(this.$store.state.hashPath)) {
        this.changeSideBarItems("commercial")
      }
      
      if (this.sidebarListItems.technology.includes(this.$store.state.hashPath)) {
        this.changeSideBarItems("technology")
      }
      
      if (this.sidebarListItems.helpdesk.includes(this.$store.state.hashPath)) {
        this.changeSideBarItems("helpdesk")
      }
      
      if (this.sidebarListItems.indicators.includes(this.$store.state.hashPath)) {
        this.changeSideBarItems("indicators")
      }
    },
    changeSideBarItems(type) {
      this.sidebarType = type;
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(color) {
      this.navbarColor = color
      this.isNavbarDark = color !== '#fff'
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
        this.disableThemeTour = true;
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    }
  },
};
</script>
